import { Component, Input } from "@angular/core";

export interface ISearchResult {
  icon: string;
  img: string;
  title: string;
  text: string;
  url: string;
}
@Component({
  selector: "search-result",
  templateUrl: "./search-result.component.html",
  styleUrls: ["./search-result.component.css"]
})
export class SearchResultComponent {
  constructor() {}
  // Public properties
  @Input() data: ISearchResult[];
  @Input() noRecordText: string;
}
